import * as Scrivito from "scrivito";
import getLanguage from "../../../../utils/getLanguage";

function GoBackButton(props) {
  const lang = getLanguage(Scrivito.currentPage());
  return (
    <Scrivito.LinkTag
      className="orange-button me-auto"
      onClick={props.previousPage}
    >
      <i className="las la-angle-left form-button-icon" />
      <span className="form-page-buttons-back">
        {lang === "de" ? "Zurück" : "Back"}
      </span>
    </Scrivito.LinkTag>
  );
}

export default GoBackButton;
